










import { Component, Mixins, Prop } from "vue-property-decorator";
import { IItem, CalculateItem } from "../../../../../../domain/document/items";

@Component({
  components: {
  }
})
export default class ExpressionViewer extends Mixins() {
  @Prop()
  source: IItem;

  get expressionText(): string {
    const text = (!!this.source && this.source instanceof CalculateItem)
      ? this.source.expression
      : null;
    return this.decodeExpressionText(text);
  }
  
  decodeExpressionText(text: string): string {
    if (text === null || text === undefined || text === "") { return ""; }
    if (text.indexOf("isTrue") < 0) { return text; }

    // シングルクォーテーションで分割して、「isTrue(」の直後のテキストをデコードする
    const splitted = text.split("'");
    let decodedText = splitted[0];
    for (let index = 1; index < splitted.length; ++index) {
      // endsWithはIE11が対応していない模様なので正規表現で対応している
      if (splitted[index - 1].match(/isTrue\($/g)) {
        decodedText += "'" + this.decode(splitted[index]);
      } else {
        decodedText += "'" + splitted[index];
      }
    }
    return decodedText;
  }

  decode(text: string): string {
    return this.decodeExpressionText(decodeURIComponent(escape(atob(text))));
  }
}
